import React, { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"

function Navigation() {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const navLinks = [
    { to: "/", text: "Home" },
    { to: "/book", text: "W.T.F. is healing?" },
    { to: "/artbreak", text: "Artbreak" },
    { to: "/painting", text: "Technical Problems" },
    { to: "/sessions", text: "Breathwork Sessions" },
    { to: "/about", text: "About Me" },
    { to: "/support", text: "Get involved" },
  ]

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-[#0a0a0a]">
      <style>
        {`
          @font-face {
            font-family: 'Ustroke';
            src: url('/fonts/Ustroke-Regular.ttf') format('truetype');
            font-weight: normal;
            font-style: normal;
          }
          .menu-icon {
            transition: transform 0.3s ease-in-out;
          }

          .menu-icon.open {
            transform: rotate(90deg);
          }
        `}
      </style>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center h-16">
          <div className="hidden md:block">
            <div className="flex items-baseline space-x-4">
              {navLinks.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`font-['Ustroke'] text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                    location.pathname === item.to
                      ? "bg-gray-700 text-white"
                      : ""
                  }`}
                >
                  {item.text}
                </Link>
              ))}
            </div>
          </div>
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-300 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              aria-expanded={isOpen}
            >
              <span className="sr-only">Toggle main menu</span>
              <span className="font-['Ustroke'] text-lg sm:text-xl">
                {isOpen ? "Close" : "Menu"}
              </span>
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden transition-all duration-300 ease-in-out">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`font-['Ustroke'] text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium ${
                  location.pathname === item.to ? "bg-gray-700 text-white" : ""
                }`}
              >
                {item.text}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  )
}

export default Navigation
